import { authState, loginProfileState } from './shared';
import { makeNonSerializableStateStore } from '@playcastdotio/StateStore';
import { isElectron } from '..';

const initialPreviewStreamState: MediaStream = new MediaStream();
const previewStreamState = makeNonSerializableStateStore<MediaStream>(initialPreviewStreamState);

const initialPreviewTrackState: {
  raw: { [channel: string]: MediaStreamTrack };
  out: { [channel: string]: { stream: MediaStream; volumeControl: (volume: number) => void } };
} = { raw: {}, out: {} };
const previewTrackState = makeNonSerializableStateStore(initialPreviewTrackState);

loginProfileState.addListener((loginProfile) => {
  if (!isElectron) {
    if (loginProfile.accessToken !== '') {
      console.debug('[Store-Remote] Updating auth state accessToken with accessToken');
      authState.currentState.accessToken = loginProfile.accessToken;
    }
    if (loginProfile.hostAuthId !== '') {
      console.debug('[Store-Remote] Updating auth state hostAuthId with hostAuthId');
      authState.currentState.hostAuthId = loginProfile.hostAuthId;
    }
    authState.updateState(authState.currentState);
  }
});

export const getRemoteClientStore = () => {
  return {
    previewStreamState,
    previewTrackState,
  };
};

export const destroyAllRemoteClientStores = (destroyListeners?: boolean) => {
  Object.values(getRemoteClientStore()).forEach((store) => store.reset(destroyListeners));
};

